import { Box, Link, List, ListItem, Text } from '@chakra-ui/react';
import { QuickLinks } from '../lib/types';
import NextLink from 'next/link';
import { LinkIcon } from '@chakra-ui/icons';

const QuickLinksBox: React.FC<QuickLinks> = ({ anchors }) => {
  return (
    <Box borderWidth="2px" rounded="md" p="6" maxW="md" bgColor="white">
      <Text
        size="sm"
        letterSpacing="wide"
        casing="uppercase"
        fontWeight="semibold"
        color="gray.500"
      >
        Quick Links
      </Text>
      <List spacing="2" pt="2">
        {anchors.map((anchor, idx) => {
          return (
            <ListItem key={idx}>
              <NextLink href={anchor.ref}>
                <Link color="brand.teal">
                  <LinkIcon /> {anchor.title}
                </Link>
              </NextLink>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default QuickLinksBox;
